const optimisticConversationMessages = ({
  received,
  optimisticIds,
  conversationId
}) => {
  const messages = []
  for (const id of optimisticIds || []) {
    const message = received && received[id]
    if (!message) continue
    if (conversationId && message.task && message.task !== conversationId) continue
    messages.push(message)
  }
  return messages
}

const mergeConversationBoundaryMessages = ({
  canonical,
  optimistic,
  preferOptimisticIds
}) => {
  const byId = new Map()
  for (const message of canonical || []) {
    if (message && message.id) byId.set(message.id, message)
  }
  for (const message of optimistic || []) {
    if (!message || !message.id) continue
    if (
      !byId.has(message.id) ||
      preferOptimisticIds && preferOptimisticIds.has(message.id)
    ) {
      byId.set(message.id, message)
    }
  }
  return Array.from(byId.values())
}

module.exports = {
  mergeConversationBoundaryMessages,
  optimisticConversationMessages
}
